import React, { useState, useEffect } from 'react';
import LoginHeader from '../Login_header';
import Menu from '../Menu';
import { Container, Row, Col, Button, Form } from 'react-bootstrap';
import AsyncSelect from 'react-select/async';
import * as Picklist from './../Picklist';
import * as Common from './../Common';
import Dialog from '../Dialog';
import DatePicker from 'react-datepicker';
import $ from "jquery";
import { useNavigate } from 'react-router-dom';

const Rep_mis = () => {

    const navigate = useNavigate();
    const sid = sessionStorage.getItem('sessionId');
    const branchDisable = sessionStorage.getItem('branchDisable');
    const [onceRun, setOnceRun] = useState(false);
    const [userRight, setUserRight] = useState([]);
    const [isMsgBox, setMsgBox] = useState(false);
    const [msgText, setMsgText] = useState('');
    const [GenerateType, setGenerateType] = useState("D");
    const [filterLocationType, setFilterLocationType] = useState("A");
    const [filterLocation, setFilterLocation] = useState(null);
    const [locationCode, setLocationCode] = useState(0);
    const [masterPrinciple, setMasterPrinciple] = useState(null);
    const [filterFromDate, setFilterFromDate] = useState(new Date());
    const [filterToDate, setFilterToDate] = useState(new Date());
    const [startEndDate, setStartEndDate] = useState({ end: "2025-04-30" });
    const [filterZone, setFilterZone] = useState("EAST");
    const [selectedMonth, setSelectedMonth] = useState(new Date(2025, 3));
    const [allLocationArray, setAllLocationArray] = useState([]);
    const [eastLocationArray, setEastLocationArray] = useState([]);
    const [westLocationArray, setWestLocationArray] = useState([]);
    const [northLocationArray, setNorthLocationArray] = useState([]);
    const [southLocationArray, setSouthLocationArray] = useState([]);
    const [filterGetReportBy, setFilterGetReportBy] = useState("FX");

    useEffect(() => {
        if (onceRun) {
            return;
        } else {
            Common.getActiveBranch().then(response => {
                setFilterLocation(response);
                response != null && handleChangeLocation(response);
            });
            Common.callApi(Common.apiRight, [sid, 'all', 'AUTOREPORT_MIS'], function (result) {
                let resp = JSON.parse(result);
                if (resp.query === "1") {
                    setUserRight(resp);
                } else {
                    navigate('/');
                }
                Common.callApi(Common.apiMis, [sid, "alllocation", "all"], result => {
                    setAllLocationArray(JSON.parse(result));
                });
                Common.callApi(Common.apiMis, [sid, "eastarray", "all"], result => {
                    setEastLocationArray(JSON.parse(result));
                });
                Common.callApi(Common.apiMis, [sid, "westarray", "all"], result => {
                    setWestLocationArray(JSON.parse(result));
                });
                Common.callApi(Common.apiMis, [sid, "northarray", "all"], result => {
                    setNorthLocationArray(JSON.parse(result));
                });
                Common.callApi(Common.apiMis, [sid, "southarray", "all"], result => {
                    setSouthLocationArray(JSON.parse(result));
                });

            });
            setOnceRun(true);
        }
    }, [onceRun, sid, navigate]);

    const handleChangeLocation = (value) => {
        setFilterLocation(value);
        const loc = value.id.split('^');
        setLocationCode(loc[1]);
        sessionStorage.activeBranch = loc[1];
    }

    const handleLocationType = (e) => {
        setFilterLocationType(e.target.value);
        if (e.target.value === 'A') {
            setLocationCode(0);
        } else {
            Common.getActiveBranch().then(response => {
                setFilterLocation(response);
                response != null && handleChangeLocation(response);
            });
        }
    }
    function callApiAsync(api, params) {
        return new Promise((resolve, reject) => {
            Common.callApi(api, params, (result) => {
                resolve(result);
            });
        });
    }
    function callDownloadAsync(api, type, params) {
        return new Promise((resolve, reject) => {
            Common.callDownloadApiPost1(api, type, params, (result) => {
                resolve(result);
            });
        });
    }
    async function downloadDataSync(locationarray) {
        setMsgText("Generating Consolidated location");
        setMsgBox(true);
        const obj = {
            generateType: GenerateType,
            filterLocationType: filterLocationType,
            location: locationCode,
            tillDate: startEndDate.end,
            filterZone: filterZone,
            filterend: false,
            filterstart: true,
            locationname: "Consolidated",
            filterGetReportBy: filterGetReportBy
        };
        // 1) First API Call
        let result = await callApiAsync(Common.apiMis, [sid, "downloaddata", JSON.stringify(obj)]);
        let resp = JSON.parse(result);
        obj["filterstart"] = false;
        obj["filename"] = resp;
        for (let item of locationarray) {
            setMsgText("Generating single location :  " + item.entity_name);
            setMsgBox(true);

            obj["location"] = item.entity_id;
            obj["locationname"] = item.entity_name;

            let r = await callApiAsync(Common.apiMis, [sid, "downloaddata", JSON.stringify(obj)]);
            let resp1 = JSON.parse(r);

            obj["filename"] = resp1;
        }

        // 3) Final POST Call
        obj["filterend"] = true;

        let finalResult = await callDownloadAsync(Common.apiMis, "post", [sid, "downloaddata", JSON.stringify(obj)]);

        $(".loader").hide();
        setMsgText(Common.buildMessageFromArray([finalResult]));
        setMsgBox(true);
    }
    const handleGenerate = () => {
        console.log(allLocationArray);
        $(".loader").show();
        if (!Common.validateFinYear(Common.dateYMD(selectedMonth))) {
            $(".loader").hide();
            setMsgText("Date should be within financial year");
            setMsgBox(true);
            return;
        }
        var msg = [], i = 0;
        if ((filterLocationType === 'O' && filterLocation === null)) {
            $(".loader").hide();
            msg[i++] = Common.getMessage("MSG0006");
            msg[i++] = ((filterLocationType === 'O' && filterLocation === null) ? "Select Location." : '')
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        } else {

            if (filterGetReportBy === 'BATCH') {
                const obj = {
                    generateType: GenerateType,
                    filterLocationType: filterLocationType,
                    location: locationCode,
                    tillDate: startEndDate.end,
                    filterZone: filterZone,
                    filterend: false,
                    filterstart: true,
                    locationname: "Consolidated",
                    filterGetReportBy: filterGetReportBy
                };
                Common.callApi(Common.apiMis, [sid, "generate_entry", JSON.stringify(obj)], result => {
                    $(".loader").hide();
                });

            } else if (GenerateType === 'D') {
                if (filterLocationType === "A") {
                    downloadDataSync(allLocationArray);
                    $(".loader").hide();

                } else if (filterLocationType === "Z") {
                    if (filterZone === 'EAST') {
                        // east consolidated and all location in east
                        downloadDataSync(eastLocationArray);
                    } else if (filterZone === 'WEST') {
                        // west consolidated and all location in west
                        downloadDataSync(westLocationArray);
                    } else if (filterZone === 'NORTH') {
                        // north consolidated and all location in north
                        downloadDataSync(northLocationArray);
                    } else {
                        // south consolidated and all location in south 
                        downloadDataSync(southLocationArray);
                    }
                    $(".loader").hide();
                } else {
                    // single location 
                    downloadDataSync([]);
                    $(".loader").hide();
                }
            }
        }
    }
    const handleMonthChange = (date) => {
        setSelectedMonth(date);
        const end = new Date(date.getFullYear(), date.getMonth() + 1, 0); // last day of the month

        setStartEndDate({ end: new Date(new Date(end).setDate(new Date(end).getDate() + 1)).toISOString().split("T")[0] });
    };

    return (
        <>
            <LoginHeader />
            <Menu />
            <Container fluid>
                <Row>
                    <Col>
                        <h3>Analysis</h3>
                    </Col>
                </Row>
                <Row>&nbsp;</Row>
                <Row>
                    <Col>
                        <Button variant='outline-success' className='buttonStyle' size='sm' onClick={handleGenerate}>Generate</Button>
                    </Col>
                </Row>
                <Row>&nbsp;</Row>
                <Row>
                    <Col className='col-md-3 col-6'>
                        <Form.Group>
                            <Form.Label>Location Type <span className="text-danger">*</span></Form.Label>
                            <Form.Select value={filterLocationType} onChange={handleLocationType}
                                required>
                                <option value="A">All</option>
                                <option value="O">One</option>
                                <option value="Z">Zone </option>
                            </Form.Select>
                        </Form.Group>
                    </Col>
                    {filterLocationType === 'O' ? <>
                        <Col className='col-md-3 col-6'>
                            <Form.Group>
                                <Form.Label>Location<span className="text-danger">*</span></Form.Label>
                                <AsyncSelect
                                    cacheOptions={false}
                                    defaultOptions={false}
                                    value={filterLocation}
                                    getOptionLabel={e => e.label + ' '}
                                    getOptionValue={e => e.id}
                                    loadOptions={Picklist.fetchLocationAllowedPicklist}
                                    onInputChange={Picklist.handleInputChange}
                                    onChange={handleChangeLocation}
                                    isDisabled={branchDisable === "true"}
                                >
                                </AsyncSelect>
                            </Form.Group>
                        </Col></> : null}
                    {filterLocationType === 'Z' ? <>
                        <Col className='col-md-3 col-6'>
                            <Form.Group>
                                <Form.Label>Which Zone<span className="text-danger">*</span></Form.Label>
                                <Form.Select value={filterZone} onChange={e => setFilterZone(e.target.value)}
                                    required>
                                    <option value="EAST">East</option>
                                    <option value="WEST">West</option>
                                    <option value="NORTH">North</option>
                                    <option value="SOUTH">South</option>
                                </Form.Select>
                            </Form.Group>
                        </Col></> : null}
                    <Col className='col-md-3 col-6'>
                        <Form.Group>
                            <Form.Label>Get Report by ?<span className="text-danger">*</span></Form.Label>
                            <Form.Select value={filterGetReportBy} onChange={e => setFilterGetReportBy(e.target.value)}
                                required>
                                <option value="FX">HERE (Take Time)</option>
                                <option value="BATCH">Through Mail(Less Time)</option>
                            </Form.Select>
                        </Form.Group>
                    </Col>
                </Row>
                <Row>&nbsp;</Row>
                <Row>
                    <Col className="col-md-3 col-6">
                        <Form.Group>
                            <Form.Label>
                                Select Month <span className="colorThemeRed">*</span>
                            </Form.Label>
                            <DatePicker
                                selected={selectedMonth}
                                onChange={handleMonthChange}
                                dateFormat="MMMM"
                                showMonthYearPicker
                                className="form-control"
                                customInput={
                                    <input
                                        type="text"
                                        readOnly // 👈 disables typing manually
                                        value={selectedMonth.toLocaleString("default", { month: "long" })}
                                    />
                                }
                            />
                        </Form.Group>
                    </Col>
                    <Col className='col-md-3 col-6'>
                        <Form.Group>
                            <Form.Label>Mode<span className="text-danger">*</span></Form.Label>
                            <Form.Select value={GenerateType} onChange={e => setGenerateType(e.target.value)}
                                required>
                                <option value="V">View</option>
                                <option value="D">Download</option>
                            </Form.Select>
                        </Form.Group>
                    </Col>
                </Row>
            </Container>
            <Dialog isOpen={isMsgBox} onClose={(e) => setMsgBox(false)}>
                {msgText}
            </Dialog>
            <Row>&nbsp;</Row>
            <Row>&nbsp;</Row>
        </>
    )
}

export default Rep_mis;
